export const HOME_IDS = {
  hero: "home-hero",
  heroCta: "hero-call-cta",
  heroWhatsapp: "hero-whatsapp-cta",
  heroOrder: "hero-order-cta",
  serviceCard: "service-card",
  orderNow: "cta-order-now",
  floatingCall: "floating-call-btn",
  floatingWhatsapp: "floating-whatsapp-btn",
};

export const ORDER_IDS = {
  form: "order-form",
  name: "order-name",
  phone: "order-phone",
  whatsapp: "order-whatsapp",
  email: "order-email",
  vehicleNumber: "order-vehicle-number",
  vehicleType: "order-vehicle-type",
  vehicleRc: "order-vehicle-rc",
  district: "order-district",
  address: "order-address",
  pincode: "order-pincode",
  serviceType: "order-service-type",
  notes: "order-notes",
  submit: "order-submit-btn",
  success: "order-success",
};

export const CONTACT_IDS = {
  form: "contact-form",
  name: "contact-name",
  phone: "contact-phone",
  email: "contact-email",
  subject: "contact-subject",
  message: "contact-message",
  submit: "contact-submit-btn",
  success: "contact-success",
};

export const ADMIN_IDS = {
  loginEmail: "admin-login-email",
  loginPassword: "admin-login-password",
  loginSubmit: "admin-login-submit",
  ordersTable: "admin-orders-table",
  contactsTable: "admin-contacts-table",
  logout: "admin-logout-btn",
  tabOrders: "admin-tab-orders",
  tabContacts: "admin-tab-contacts",
};
